// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1-8Ih","icon":"SortAdornment_icon__zggKk","up":"SortAdornment_up__2fCRm","down":"SortAdornment_down__2LGdM","active":"SortAdornment_active__3QEJV"};